enum ConfirmationModalText {
  Text = 'Are you sure you want to leave without saving information?',
  ButtonLeaveText = 'Yes',
  ButtonStayText = 'No'
}

export default ConfirmationModalText;
